module.exports = __webpack_public_path__ + "static/img/kong.023c6d64.png";